import { logger } from 'utils/logger';

export const PROMPT_PAINT_DELAY = 1000;

export const openPipDuringScreenPicker = async (
  picker: Promise<unknown>,
  openPip: () => Promise<void>
) => {
  let pickerDismissed = false;
  let promptTimer = 0;

  const pickerSettled = picker.then(
    () => {},
    () => {
      pickerDismissed = true;
    }
  );

  const promptPainted = new Promise<void>((resolve) => {
    promptTimer = window.setTimeout(resolve, PROMPT_PAINT_DELAY);
  });

  try {
    await Promise.race([promptPainted, pickerSettled]);
  } finally {
    window.clearTimeout(promptTimer);
  }

  if (pickerDismissed) {
    logger.remote({ capture: 'pip' }).info('[PiP] auto-PiP skipped: the picker was dismissed');

    return false;
  }

  await openPip();
  logger.remote({ capture: 'pip' }).info('[PiP] auto-PiP opened alongside the screen picker');

  return true;
};
